
import {Component, Prop, Mixins, Watch, Ref} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import {NotEntity} from "@/entity/NotEntity";
import NotTurPicker from "@/components/pickers/NotTurPicker.vue";
import NotEditor from "@/components/inputs/NotEditor.vue";
import NotInfo from "@/components/infos/NotInfo.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {NotTuru} from "@/enum/NotTuru";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import NotForm from "@/components/forms/NotForm.vue";

interface Options {
  sortBy: string[];
  sortDesc: boolean[];
  page: number;
  itemsPerPage: number;
}

@Component({
  components: {NotForm, FormDialog, FormWrapper, NotInfo, NotEditor, NotTurPicker}
})

export default class NotList extends Mixins(SimpleInputMixin) {
  @Prop() defaultType!: number;
  @Prop() defaultBorclu!: number;
  @Prop({required: true}) takipId!: number;
  @Prop() hideCloseButton!: boolean | string;
  @Prop() hideElevation!: boolean | string;
  @Ref('notForm') readonly notForm!: NotForm;
  @Prop() alacakliBorcluVisible!: boolean;
  @Prop({ default: 'Vazgeç' }) closeButtonText!: string;
  @Prop({ type: Boolean, default: false }) closeButtonAlignRight!: boolean;
  localValue!: Array<NotEntity>;
  selectedType: Array<any> = [];
  notFormKey = 0;
  notTuru = NotTuru;
  loading = false;
  totalRecordCount = 0;

  // Sunucudan gelen ham liste (filtre uygulanmadan)
  private allItems: Array<NotEntity> = [];

  options: Options = {
    sortBy: ['updated_at'],
    sortDesc: [true],
    page: 1,
    itemsPerPage: 5
  };

  headers = [{ text: 'Notlar', value: 'not', sortable: false }];

  get defaultNot(){
    const notObject = new NotEntity();
    notObject.not = '<p></p>';
    return notObject;
  }

  onNotDialogVisibilityChange(isVisible: boolean) {
    if (isVisible) this.notFormKey++;
  }

  get isHideClose() { return (this.hideCloseButton || this.hideCloseButton === ""); }
  get isHideElevation() { return this.hideElevation || this.hideElevation === ""; }

  @Watch('selectedType', { deep: true })
  onFilterChange() {
    this.options.page = 1;
    this.applyClientFilter();
  }

  @Watch('options', { deep: true })
  onOptionsChange(newVal: Options, oldVal: Options) {
    if (!oldVal) return;
    if (newVal.page !== oldVal.page ||
        newVal.sortBy.toString() !== oldVal.sortBy.toString() ||
        newVal.sortDesc.toString() !== oldVal.sortDesc.toString() ||
        newVal.itemsPerPage !== oldVal.itemsPerPage) {
      this.load();
    }
  }

  @Watch('takipId')
  onTakipChanged() {
    this.options.page = 1;
    this.load();
  }

  mounted() {
    if (this.defaultType) this.selectedType.push(this.defaultType);
    this.$nextTick(() => this.load());
  }

  onIsAdded() {
    this.$emit('isAdded');
    this.load();
  }

  onCloseClick() {
    this.$emit('onClose');
  }

  // Seçimi id dizisine normalize et
  private getSelectedTypeIds(): number[] {
    if (!Array.isArray(this.selectedType)) return [];
    return this.selectedType
        .map((v: any) => (v && typeof v === 'object' ? v.id : v))
        .filter((v: any) => v !== null && v !== undefined && String(v).trim() !== '')
        .map((v: any) => Number(v))
        .filter((n: any) => !Number.isNaN(n));
  }

  // Client-side filtre uygulaması
  private applyClientFilter() {
    const ids = this.getSelectedTypeIds();
    const base = this.allItems || [];
    this.localValue = ids.length === 0
        ? base
        : base.filter((n: any) => ids.includes(Number(n.not_tur_id)));
    this.totalRecordCount = this.localValue.length;
    this.sortFavorites();
  }

  load() {
    this.loading = true;
    const { sortBy, sortDesc, page, itemsPerPage } = this.options;

    const params: any = {
      sortBy: sortBy[0] || 'updated_at',
      sortDesc: sortDesc[0],
      page,
      paginate: itemsPerPage,
      takip: this.takipId, // sadece takip'e göre çek
    };

    this.$http.get("/api/v1/not/filter", { params })
        .then((response: any) => {
          if (response?.data && Array.isArray(response.data.data)) {
            this.allItems = response.data.data;   // ham liste
            this.applyClientFilter();             // seçime göre front-end filtresi
          } else {
            this.allItems = [];
            this.localValue = [];
            this.totalRecordCount = 0;
          }
          this.loading = false;
        })
        .catch(error => {
          console.error('Not listesi yüklenirken hata oluştu:', error);
          this.loading = false;
          this.allItems = [];
          this.localValue = [];
          this.totalRecordCount = 0;
        });
  }

  sortFavorites() {
    if (this.localValue && this.localValue.length > 0) {
      const favoriNotlar = this.localValue.filter((n: any) => n.favori_mi === true);
      const normalNotlar = this.localValue.filter((n: any) => n.favori_mi !== true);
      this.localValue = [...favoriNotlar, ...normalNotlar];
    }
  }

  isAuthorized(keySuffix: string) {
    let ap = this.$store.state.activeProcesses;
    let authKey: string | null = null;
    if (keySuffix[0] !== '-') keySuffix = '-' + keySuffix;
    if (ap.filter((item: any) => item.key === "takip-ac").length > 0) {
      authKey = "takip-ac";
    } else if (ap.filter((item: any) => item.key === "takip-duzenle").length > 0) {
      authKey = 'takip-not' + keySuffix;
    }
    if (!authKey) return false;
    return this.$helper.isAuthorized(authKey);
  }
}
